import * as Api from '../api/Api';
import createAxios from '../api/WiseOwl';

export const getAll = () => {
    return createAxios().get(Api.PATH_TEXT_TO_SPEECH_TRANSFORM);
};

export const update = (values) => {
    return createAxios().put(Api.PATH_TEXT_TO_SPEECH_TRANSFORM, values);
};